module.exports = __webpack_public_path__ + "img/icon_catalogo_materiales_y_equipos.ebddca80.svg";